export function StepsSection() {
  const steps = [
    {
      title: '1. Créez vos produits',
      desc: 'Importez ou créez vos articles, prix & catégories.',
    },
    {
      title: '2. Stockez & vendez',
      desc: 'Suivez entrées/sorties, encaissez et générez vos factures.',
    },
    {
      title: '3. Pilotez',
      desc: 'Visualisez marges, rotations, dettes & paiements.',
    },
  ]
  return (
    <section className='mx-auto max-w-7xl px-4 py-16'>
      <h2 className='text-3xl font-bold text-center'>En 3 étapes simples</h2>
      <div className='mt-10 grid grid-cols-1 md:grid-cols-3 gap-6'>
        {steps.map((s, i) => (
          <div key={s.title} className='rounded-xl border p-6'>
            <div className='text-primary font-bold text-sm'>Étape {i + 1}</div>
            <div className='mt-2 text-lg font-semibold'>{s.title}</div>
            <div className='text-sm text-muted-foreground mt-1'>{s.desc}</div>
          </div>
        ))}
      </div>
    </section>
  )
}
